import './DecoBall.scss'

export const DecoBall = ({children, id, style}) => {
    return (
        <div aria-hidden="true" className="deco-ball" id={id} style={style}>
            {children}
        </div>
    )
}